import { AxiosService } from '../../axios/axios.service';
import type { tFeatureFlagsResponse } from './FeatureFlags.types';

export const FeatureFlagsService = Object.freeze({
  getByWorkspace: async function (
    workspaceId: string,
  ): Promise<tFeatureFlagsResponse> {
    // RET-1922 review — the provider retries this call up to 3 times per
    // resolution, so a dead network would emit 3 Sentry captures per page
    // load. Per-attempt failures are expected and handled; the DEFINITIVE
    // failure is the signal, and it is reported once by the provider (LLog +
    // `front.flags.resolution_failed`), not by the transport.
    return AxiosService.get<tFeatureFlagsResponse>(
      `workspace/${workspaceId}/feature-flags`,
      { skipSentryCapture: true },
    );
  },
});
